module.exports = __webpack_public_path__ + "static/media/sparkChain.f6f01234.webp";